<div class="left-column">
  <div class="top-part">
    <div class="title">Retailer</div>
    <div class="number">{{ shopId }}</div>
  </div>
  <div class="bottom-part">
    <img
      src="/assets/img/game/i-white.svg"
      (click)="onInfoClicked()"
    >
    <div>Store Details</div>
  </div>
</div>
<div class="right-column">
  <div>{{ feedback }}</div>
</div>